export default "__VITE_ASSET__kYQ7I3On__"